import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;
const isDev = import.meta.env.MODE === 'development';

if (dsn) {
  Sentry.init({
    dsn,

    environment: import.meta.env.VITE_SENTRY_ENV || import.meta.env.MODE,

    sendDefaultPii: true,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),

      // Capture console.error and console.warn as Sentry issues (Issues tab)
      Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),

      // Forward console.log/warn/error to Sentry Logs section
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),

      // Automatically capture failed HTTP requests (fetch/XHR) — covers CORS blocks,
      // network failures, and 4xx/5xx responses the app does not explicitly handle
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
      }),

      // Capture unhandled promise rejections not caught anywhere else
      Sentry.extraErrorDataIntegration({ depth: 5 }),
    ],

    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACE_RATE) || 1.0,

    // Match all SEIN API backends: local dev + production domains
    tracePropagationTargets: [
      /^http:\/\/localhost:7070/,
      /^http:\/\/api\.lvh\.me:7070/,
      /^https?:\/\/.*\.api\.(sageterminal|seinterminal|sagetechnologypartners)\.com/,
      /^https?:\/\/.*\.api\.seinterminal\.dev/,
    ],

    replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_SESSION_RATE) || 0.1,
    replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_ERROR_RATE) || 1.0,

    enableLogs: true,

    debug: isDev,
  });
}
